import { FormControl, MenuItem, Select } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import dataProvider from '../../../../providers/dataProvider';
import { useOverviewContext } from './OverviewContext';

interface Props {
  index: number;
  img: string;
  handleChangeProperty: (
    index: number,
    fieldName: string,
    value: string
  ) => void;
}

export const PropertyIconSelect = (
  { img, handleChangeProperty, index }: Props,
  props
) => {
  const [image, setImage] = useState(img || '');
  const [icons, setIcons] = useState([]);
  const prizeType = useOverviewContext();
  useEffect(() => {
    getIcons(index, img);
  }, []);

  useEffect(() => {
    if (img) {
      setImage(img);
    } else {
      setImage(icons[index]);
    }
  }, [img]);

  useEffect(() => {
    if (image) {
      handleChangeProperty(index, 'icon', image);
    }
  }, [image]);

  const getIcons = async (index, img) => {
    const iconsArr: any = await dataProvider.getOverviewIcons(prizeType);

    const currentImg = !!img ? img : iconsArr.data[index];
    setImage(currentImg);
    setIcons(iconsArr.data);
  };

  const handleChage = (event) => {
    handleChangeProperty(index, event.target.name, event.target.value);
  };

  return (
    <FormControl size='small' variant='outlined' className='PropertyIconSelect'>
      <Select
        id='propertyMenuItem'
        name='icon'
        value={image}
        renderValue={(value) => {
          const imgFile = `${process.env.REACT_APP_AWS_S3_URL}/${image}`;
          return <img className='propertyIcon' src={imgFile} />;
        }}
        onChange={handleChage}
      >
        {/* <div className="propertyImgSelect"> */}
        {icons.length > 0 &&
          icons.map((imgName) => {
            const imgFile = `${process.env.REACT_APP_AWS_S3_URL}/${imgName}`;
            return (
              <MenuItem key={imgName} value={imgName}>
                <img className='propertyIcon_optionItem' src={imgFile} />
              </MenuItem>
            );
          })}
        {/* </div>  */}
      </Select>
    </FormControl>
  );
};
